import { Component, OnInit, HostListener } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { AplicacionesService } from '../aplicaciones/aplicaciones.service';
import { PerfilesService } from './perfiles.service';
import { TablesService } from '../generico/tables/tables.service';
import { MatDialog } from '@angular/material/dialog';
import { AccionesMenuPerfilComponent } from '../acciones-menu-perfil/acciones-menu-perfil.component';
import { AccesosPerfilService } from '../acciones-menu-perfil/accesos-perfil.service';

@Component({
  selector: 'app-perfiles',
  templateUrl: './perfiles.component.html',
  styleUrls: ['./perfiles.component.scss']
})
export class PerfilesComponent implements OnInit {

  recurso_perfil ='obtenerPerfiles';
  columns_perfil = ['id','descripcion', 'estado', 'acciones'];
  nombre_tabla = 'data-table-perfiles';
  target
  params = {};

  perfilesForm = this.fb.group({
    txt_descripcion: [null, Validators.required],
    ind_estado : [true]

  });


  constructor(private fb: FormBuilder,
              private app_serv : AplicacionesService, 
              private tb_serv : TablesService,
              private dialog: MatDialog,
              private accesos_serv : AccesosPerfilService,
              private perf_serv : PerfilesService) {
                this.params['app'] = app_serv.get_aplicacion().id_aplicacion;
              }

  ngOnInit(): void {
    this.target = document.querySelector('#btn_guardar_perfil');
  }

  onSubmit() {
    this.gestionar_perfil();
  }

  gestionar_perfil(){
    let request = {
      'app' : this.app_serv.get_aplicacion().id_aplicacion
    };
    let data_form  = this.perfilesForm.value;

    data_form.ind_estado = data_form.ind_estado? 1 : 0;

    if (this.perf_serv.id_perfil){
      data_form['id_p_perfil'] = this.perf_serv.id_perfil;
    }

    request['perfiles'] = [data_form];

    this.perf_serv
        .gestionar_perfil(request)
        .then(
          ()=>{
            this.perfilesForm.reset();
            this.perf_serv.id_perfil = null
            this.tb_serv.tablas[this.nombre_tabla].cargar_datos(this.params);
          }
        );
  }

  @HostListener('editar_perfil')
  editar_perfil(){

    let perfil = this.tb_serv.params_event.perfil;
    this.perfilesForm.get('txt_descripcion').setValue(perfil.descripcion);
    this.perfilesForm.get('ind_estado').setValue(perfil.ind_estado);
    this.perf_serv.id_perfil = perfil.id;

  }

  @HostListener('add_accion_menu')
  add_accion_menu(){
    let perfil = this.tb_serv.params_event.perfil;
    this.accesos_serv.id_perfil = perfil.id;
    const dialogRef = this.dialog.open(AccionesMenuPerfilComponent, {
      width: '800px',
    });

    this.accesos_serv.dialoRef = dialogRef;
  }

  /**
   * Evento para el boton cancelar.
   */
  cancelar(){

    this.perfilesForm.get('txt_descripcion').setValue('');
    this.perfilesForm.get('ind_estado').setValue(true);
    this.perf_serv.id_perfil = null;
  }
}
